import React, { useState, useEffect } from 'react';
import apis from '../../api';
import './index.less';
import { cloneDeep } from 'lodash';
import { CaretRightOutlined } from '@ant-design/icons';
import { message } from 'antd';
import LastLayer from './components/last-layer';
import { toListMore } from './utils';
import { studyVideoLog } from './log';
import GetVideoName from './get-video-name';
import Container from '@/components/container';
import LiveIcon from './components/live-icon';
import VideoIcon from './components/video-icon';
import QuestionIcon from './components/question-icon';
import CommonAsk from './components/common-ask';
import Empty from '@/components/core-empty';

const HelpCenterSide = () => {
  const [data, setData] = useState({ video: [], hotPaper: {} });
  const [empty, setEmpty] = useState(false);

  useEffect(() => {
    // 请求首页列表数据
    const conditions = {
      source: 'client',
    };
    apis
      .HelpListHomePageCategory(conditions)
      .then((res) => {
        if (res && res.ret === '0') {
          if (res.data?.list?.length > 0) {
            let dataCopy = cloneDeep(res.data.list);
            let finalData = [];
            dataCopy.forEach((item) => {
              if (item.childList.length <= 0) {
                dataCopy = dataCopy.filter((value) => value.id !== item.id);
              }
            });
            let firstLayer = dataCopy.filter((item) => item.showStyle === 1) || [];
            let secondLayer = dataCopy.filter((item) => item.showStyle === 3) || [];
            let thirdLayer = dataCopy.filter((item) => item.showStyle === 4) || [];
            let fourthLayer = dataCopy.filter((item) => item.showStyle === 5) || [];
            finalData = [
              ...firstLayer.slice(0, 1),
              ...thirdLayer.slice(0, 1),
              ...secondLayer.slice(0, 1),
              ...fourthLayer.slice(0, 1),
            ];
            setData({ video: finalData, hotPaper: fourthLayer[0] });
          } else {
            setEmpty(true);
          }
        } else {
          message.error(res.msg);
        }
      })
      .catch((err) => {
        message.error(err);
      });
  }, []);

  return (
    <Container
      margin={{ horizontal: false, bottom: false, top: true }}
      padding
      style={{ backgroundColor: '#FAFAFA', borderRadius: '8px' }}
    >
      <div
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        className="help-center-side"
      >
        <div className="help-center-title">学习与帮助</div>
        <span onClick={() => window.open(toListMore())} className="more">
          更多帮助
          <CaretRightOutlined style={{ color: 'rgba(0, 0, 0, 0.65)' }} />
        </span>
      </div>
      {empty ? (
        <Empty />
      ) : (
        <>
          <div className="help-center-ul">
            {data.video.map((item) => {
              if (item.showStyle === 4) {
                // 直播类型
                if (item.childList[0]?.type !== 2) return null;
                return (
                  <div onClick={() => studyVideoLog(1)} className="help-center-li">
                    <div className="li-item-title">
                      <LiveIcon />
                      直播课程
                    </div>
                    <GetVideoName value={item.childList[0]} showStyle={4} />
                  </div>
                );
              }
              if (item.showStyle === 3) {
                // 视频教程
                return (
                  <>
                    <div onClick={() => studyVideoLog(2)} className="help-center-li">
                      <div className="li-item-title">
                        <VideoIcon />
                        视频教程
                      </div>
                      <GetVideoName value={item.childList[0]} showStyle={3} />
                    </div>
                    {item.buildVideoList[0] && item.buildVideoList[0].id !== item.childList[0].id ? (
                      <div onClick={() => studyVideoLog(3)} className="help-center-li">
                        <div className="li-item-title">
                          <VideoIcon />
                          视频教程
                        </div>
                        <GetVideoName value={item.buildVideoList[0]} showStyle={3} />
                      </div>
                    ) : (
                      <div onClick={() => studyVideoLog(3)} className="help-center-li">
                        <div className="li-item-title">
                          <VideoIcon />
                          视频教程
                        </div>
                        <GetVideoName value={item.buildVideoList[1]} showStyle={3} />
                      </div>
                    )}
                  </>
                );
              }
            })}
            <div className="help-center-li">
              <div className="li-item-title">
                <QuestionIcon />
                常见问题
              </div>
              <CommonAsk />
            </div>
          </div>
          {data.hotPaper && (
            <div className="help-center-ul" onClick={() => studyVideoLog(4)}>
              <LastLayer item={data.hotPaper} />
            </div>
          )}
        </>
      )}
    </Container>
  );
};

export default HelpCenterSide;
